<template>
  <footer class="app-footer">
    <span>&copy; 2018 RedPost project team.</span>
    <span class="ml-auto">Powered by <a href="https://ap-northeast-1.console.aws.amazon.com/console/home">AWS</a></span>
  </footer>
</template>
<script>
export default {
  name: 'c-footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue